export type Image = {
  alt: string;
  image: {
    height: number;
    src: string;
    srcset: string;
    width: number;
  };
  lazy: boolean;
  sources: {
    height: number;
    media: string;
    srcset: string;
    width: number;
  }[];
};

export type OptionalImage = Image | null;

export type ProductPrice = {
  [key: string]: {
    currency: string;
    currencyCode: string;
    priceOnDemand: boolean;
    shouldDisplayCurrencyFirst: boolean;
    text: string;
    value: number;
    vatInformation: string;
  };
};

export type OpeningHoursInterval = {
  start: string;
  end: string;
};

export type OpeningHours = {
  [key: string]: {
    isClosed: boolean;
    openIntervals: OpeningHoursInterval[];
  };
};

export type FilterData = {
  id: string;
  label: string;
  component: string;
  items: FilterDataItem[];
};

export type FilterDataItem = {
  count: number;
  label: string;
  value: string;
  valueName?: string;
};

export type SearchOptions = {
  page?: number;
};

export const isImage = (property: unknown): property is Image =>
  typeof property === 'object' && property.hasOwnProperty('image');
